export const FORM_FIELDS = {
  BANNERS: {
    name: 'banners',
    label: 'Current banners',
    rules: [{ min: 1, max: 3 }],
  },
};

export const INITIAL_VALUES = {
  banners: [],
};
